import React from "react";
import "./DecisionEngine.css";

function DecisionEngine({
  decision = "WAIT",
  confidence = 0,
  risk = "Unknown",
  reason = "The AI Assistant is still analyzing the setup.",
  nextTrigger = "Waiting for confirmation",
  variant = "default",
}) {
  const getDecisionTone = (value = "") => {
    const normalizedValue = value.toLowerCase();

    if (
      normalizedValue.includes("entry confirmed") ||
      normalizedValue.includes("prepare entry") ||
      normalizedValue.includes("entry building") ||
      normalizedValue.includes("watch breakout")
    ) {
      return "decisionEnginePositive";
    }

    if (
      normalizedValue.includes("do not enter") ||
      normalizedValue.includes("risk too high") ||
      normalizedValue.includes("blocked") ||
      normalizedValue.includes("no trade")
    ) {
      return "decisionEngineDanger";
    }

    return "decisionEngineWaiting";
  };

  const safeConfidence = Math.min(
    Math.max(Number(confidence) || 0, 0),
    100
  );

  if (variant === "command") {
    return (
      <div
  className="decisionEngine decisionEngineCommand"
  data-tour-id="nina-decision-command"
>
        <div className="decisionCommandIdentity">
          <span aria-hidden="true">⌛</span>
          <div>
            <small>AI DECISION</small>
            <h3 className={getDecisionTone(decision)}>{decision}</h3>
          </div>
        </div>
        <div className="decisionCommandReason">
          <span>Why</span>
          <strong>{reason}</strong>
        </div>
        <div className="decisionCommandTrigger">
          <span>Next Trigger</span>
          <strong>{nextTrigger}</strong>
        </div>
        <div className="decisionCommandMetric">
          <span>Confidence</span>
          <strong>{safeConfidence}%</strong>
        </div>
        <div className="decisionCommandMetric">
          <span>Risk</span>
          <strong>{risk}</strong>
        </div>
        <div className="decisionCommandStatus">MONITORING</div>
        <div className="decisionEngineProgress">
          <div style={{ width: `${safeConfidence}%` }} />
        </div>
      </div>
    );
  }

  return (
    <div
      className={`decisionEngine${
        variant === "command" ? " decisionEngineCommand" : ""
      }`}
    >
      <div className="decisionEngineHeader">
        <div>
          <span className="decisionEngineEyebrow">
            AI DECISION ENGINE
          </span>

          <h3>🧠 One Source of Truth</h3>
        </div>

        <div className="decisionEngineConfidence">
          <strong>{safeConfidence}%</strong>
          <span>Confidence</span>
        </div>
      </div>

      <div className="decisionEngineMain">
        <div className="decisionEngineDecision">
          <span>Current Decision</span>

          <strong className={getDecisionTone(decision)}>
            {decision}
          </strong>
        </div>

        <div className="decisionEngineRisk">
          <span>Risk</span>
          <strong>{risk}</strong>
        </div>
      </div>

      <div className="decisionEngineReason">
        <span>Why the AI Assistant Decided This</span>
        <p>{reason}</p>
      </div>

      <div className="decisionEngineTrigger">
        <span>Next Trigger</span>
        <strong>{nextTrigger}</strong>
      </div>

      <div className="decisionEngineProgress">
        <div
          style={{
            width: `${safeConfidence}%`,
          }}
        ></div>
      </div>
    </div>
  );
}

export default DecisionEngine;
